import React from 'react';
import { UserPlus, Upload, PhoneCall } from 'lucide-react';
import useInView from '../hooks/useInView';

/* No `art` any more. The three vector illustrations came off: this section
   is a process, and threading the eye along a rail says "steps" far better
   than three unrelated drawings did. SetupArt and LeadsArt are still used by
   UseCases and Features, so nothing is orphaned by dropping them here. */
const STEPS = [
  {
    num: '01',
    icon: UserPlus,
    accent: 'accent-1',
    title: 'Sign up & set up',
    description:
      'Create your WASLX account, configure campaign settings and add your team. Under ten minutes, and no IT team required.',
    tag: '< 10 min',
  },
  {
    num: '02',
    icon: Upload,
    accent: 'accent-5',
    title: 'Add agents & upload leads',
    description:
      'Invite agents with a link. Upload your lead list as a CSV. Assign leads to campaigns and agents automatically.',
    tag: 'CSV or CRM',
  },
  {
    num: '03',
    icon: PhoneCall,
    accent: 'accent-4',
    title: 'Start calling',
    description:
      'Agents install the Android app and dial immediately. The auto dialer queues calls, skips unanswered numbers and logs every interaction.',
    tag: 'Go live today',
  },
];

const HowItWorksSection = () => {
  const [ref, inView] = useInView();

  return (
    <section ref={ref} className={`section section--muted reveal ${inView ? 'is-inview' : ''}`}>
      <div className="container-page">
        <div className="section-head">
          <span className="eyebrow accent-4">How it works</span>
          <h2 className="section-title">
            Up and running in <span className="display-accent">three steps</span>
          </h2>
          <p className="section-sub">
            No hardware. No IT vendor. No month-long rollout. Just sign up and dial.
          </p>
        </div>

        <div className="steprail">
          {STEPS.map((step, i) => {
            const Icon = step.icon;
            return (
              <div
                key={step.num}
                className={`${step.accent} steprail__item reveal-color`}
                style={{ '--reveal-delay': `${i * 120}ms` }}
              >
                <span className="steprail__ghost" aria-hidden="true">
                  {step.num}
                </span>

                <span className="steprail__node">
                  <Icon className="h-6 w-6" />
                </span>

                <h3 className="steprail__title">{step.title}</h3>
                <p className="steprail__body">{step.description}</p>

                <span className="chip mt-4">{step.tag}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
